import type { ConversationTimelineEventResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event-response";
import { Text } from "@redotech/redo-web/text";
import { Tooltip } from "@redotech/redo-web/tooltip/tooltip";
import { formatTimeAgo } from "@redotech/util/date-format";
import { memo } from "react";

function getActorLabel(event: ConversationTimelineEventResponse): string {
  switch (event.actorType) {
    case "SYSTEM":
      return "System";
    case "RULE":
      return "Automation";
    case "USER":
      return "Agent";
    case "CUSTOMER":
      return "Customer";
    case "AI":
      return "AI";
    case "EXTERNAL_USER":
      return "External";
    default:
      return "";
  }
}

export const EventTimestamp = memo(function EventTimestamp({
  event,
}: {
  event: ConversationTimelineEventResponse;
}) {
  const actorLabel = getActorLabel(event);

  return (
    <Tooltip
      arrow
      placement="bottom"
      title={event.occurredAt.toLocaleString([], {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      })}
    >
      <span>
        <Text fontSize="xxs" textColor="tertiary">
          {actorLabel} · {formatTimeAgo(event.occurredAt.toISOString())}
        </Text>
      </span>
    </Tooltip>
  );
});
